import { createTranslation } from '@choffmeister/i18next'
import { i18n, TFunction } from 'i18next'

import { Translations } from '../hooks/useLanguage'
import { AcceptedLanguages } from '../i18n'

// A generic, safe return type
type SafeUseTranslationResponse<TKeys extends string> = {
  t: TFunction<TKeys>
  i18n: i18n
  ready: boolean
}

export const createTypedTranslation = <T extends object>(resources: T) => {
  const { useTranslation: useOriginalTranslation } = createTranslation(resources)

  // This is our reusable, type-safe hook
  const useTypedTranslation = (): SafeUseTranslationResponse<keyof T & string> => {
    const { t, i18n, ready } = useOriginalTranslation()

    return {
      i18n: i18n as i18n,
      ready: ready as boolean,
      t: t as TFunction<keyof T & string>,
    }
  }

  return useTypedTranslation
}

// export for AppBlock.tsx
export const resolveText = (
  prop: Translations | string | undefined,
  fallbackKey: string,
  t: TFunction,
  language: AcceptedLanguages
): string => {
  // Case 1: The prop is a direct string.
  if (typeof prop === 'string') {
    return prop
  }
  // Case 2: The prop is a Translations object.
  if (prop) {
    return prop[language] || prop.en
  }
  // Case 3: The prop is undefined, so use the fallback key with t().
  return t(fallbackKey)
}
